import data from "../../.sourceflow/assets.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const assets_helper = new CollectionHelper(data);
